export default "__VITE_ASSET__D2zrOF5q__"